<template>
    <div>
        <div class="modal hide fade" id="modalInventoryPurchasing" tabindex="0" role="dialog" aria-labelledby="modalInventoryPurchasing" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Purchasing</h4>
                    </div>
                    <div class="modal-body">
                        <table class="table table-item mb-0 table-sm table-hover">
                            <thead>
                                <th><label class="form-checkbox"><input type="checkbox" v-model="selectAll" @click="select"><i class="form-icon"></i></label></th>
                                <th>Status</th>
                                <th>Purchasing No.</th>
                                <th>SP No.</th>
                                <th>Date</th>
                                <th>Total</th>
                                <th>Vendor</th>
                            </thead>
                            <tbody>
                                <tr v-for="p in purchasingListVendor" :key="p.id">
                                    <td><label class="form-checkbox"><input type="checkbox" :value="p.id" v-model="selected"><i class="form-icon"></i></label></td>
                                    <td>{{ p.status }}</td>
                                    <td>{{ p.purchasing_no }}</td>
                                    <td>{{ p.sp_no }}</td>
                                    <td>{{ p.purchasing_date | dateFormat('DD/MM/YYYY') }}</td>
                                    <td>{{ p.total | currency }}</td>
                                    <td>{{ p.vendor_no }} - {{ p.vendor }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <!-- <pre>{{ purchasingList }}</pre> -->
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-sm btn-soft-primary pull-right" data-dismiss="modal">Cancel</button>
                        <button class="btn btn-sm btn-hard-primary pull-right" data-dismiss="modal" @click="selectPurchasing">Select</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal hide fade" id="modalPurchasingId" tabindex="0" role="dialog" aria-labelledby="modalInventoryPurchasing" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Purchasing - {{ purchasing.purchasing_no }}</h5>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-4">
                                <dl class="row">
                                    <dt class="col-sm-4">Invoice No.</dt>
                                    <dd class="col-sm-8">{{ purchasing.ext_no }}</dd>
                                </dl>
                                <dl class="row">
                                    <dt class="col-sm-4">SP No.</dt>
                                    <dd class="col-sm-8">{{ purchasing.sp_no }}</dd>
                                </dl>
                            </div>
                            <div class="col-md-4">
                                <dl class="row">
                                    <dt class="col-sm-4">Vendor</dt>
                                    <dd class="col-sm-8">{{ purchasing.vendor }}</dd>
                                </dl>
                                <dl class="row">
                                    <dt class="col-sm-4">Tax</dt>
                                    <dd class="col-sm-8">{{ purchasing.taxes }}</dd>
                                </dl>
                            </div>
                            <div class="col-md-4">
                                <dl class="row">
                                    <dt class="col-sm-4">Date</dt>
                                    <dd class="col-sm-8">{{ purchasing.purchasing_date | dateFormat('DD/MM/YYYY') }}</dd>
                                </dl>
                                <dl class="row">
                                    <dt class="col-sm-4">Due Date</dt>
                                    <dd class="col-sm-8">{{ purchasing.purchasing_due_date | dateFormat('DD/MM/YYYY') }}</dd>
                                </dl>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="table-responsive">
                                    <table class="table table-sm table-item table-hover table-striped">
                                        <thead>
                                            <th style="width: 30%">Product</th>
                                            <th style="width: 10%">Qty</th>
                                            <th style="width: 10%">Done</th>
                                            <th style="width: 10%">UoM</th>
                                            <th style="width: 10%">Price</th>
                                            <th style="width: 10%">Discount</th>
                                            <th style="width: 10%">Tax</th>
                                            <th style="width: 20%">Sub Total</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="d in purchasingListDetail" :key="d.id" >
                                                <td>{{ d.product_no }} - {{ d.product }}</td>
                                                <td>{{ d.qty }}</td>
                                                <td>{{ d.qty_done }}</td>
                                                <td>{{ d.uom_id }}</td>
                                                <td>{{ d.price | currency }}</td>
                                                <td>{{ d.discount | currency }}</td>
                                                <td>{{ d.tax | currency }}</td>
                                                <td>{{ d.total | currency }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-sm btn-soft-primary pull-right" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal hide fade" id="modalRequestEdit" tabindex="-1" role="dialog" aria-labelledby="modalRequestEdit" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                  <div class="modal-header red darken-3 text-left text-white">
                      <h4 class="modal-title w-100 font-weight-bold">Request Edit</h4>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                      </button>
                  </div>
                  <div class="modal-body">
                      <form>
                          <div class="form-group">
                              <label for="request_edit" class="col-form-label">Request:</label>
                              (max: <span v-text="(max - request_edit.length)" style="color: blue;"></span>)
                              <textarea v-model="request_edit" class="form-control" rows="5" :maxlength="max"/>
                          </div>
                      </form>
                  </div>
                  <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                  <button type="button" class="btn btn-primary" data-dismiss="modal" @click="requestEdit">Process</button>
                  </div>
              </div>
          </div>
      </div>
      <div class="modal hide fade" id="modalRequestVoid" tabindex="-1" role="dialog" aria-labelledby="modalRequestVoid" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                  <div class="modal-header red darken-3 text-left text-white">
                      <h4 class="modal-title w-100 font-weight-bold">Request Void</h4>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                      </button>
                  </div>
                  <div class="modal-body">
                      <form>
                            <div class="form-group">
                                <label for="request_edit" class="col-form-label">Request: </label>
                                (max: <span v-text="(max - request_void.length)" style="color: blue;"></span>)
                                <textarea v-model="request_void" class="form-control" rows="5" :maxlength="max"/>
                            </div>
                      </form>
                  </div>
                  <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                  <button type="button" class="btn btn-primary" data-dismiss="modal" @click="requestVoid">Process</button>
                  </div>
              </div>
          </div>
      </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'InventoryPurchasingModal',
  props: ['inventory'],
  computed: {
    ...mapState({
      purchasingList: state => state.purchasings.purchasingList,
      purchasingTypeList: state => state.purchasingTypes.purchasingTypeList,
      vendorList: state => state.vendors.vendorList,
      termDueList: state => state.termduedates.termDueList,
      purchasing: state => state.purchasings.purchasingID,
      taxList: state => state.taxes.taxList
    }),
    purchasingListVendor () {
      var vendorNo = this.inventory.vendor_no
      var loop = []
      if (vendorNo) {
        loop = this.purchasingList.filter(d => d.vendor_no === vendorNo).filter(d => d.company_no === this.inventory.company_no)
      } else {
        loop = this.purchasingList
      }
      return loop
    },
    purchasingListDetail: function () {
      var array2 = this.purchasing.details
      var loop = []
      for (let a = 0; a < array2.length; a++) {
        var obj = {
          id: array2[a].id,
          purchasing_no: array2[a].purchasing_no,
          purchasing_date: array2[a].purchasing_date,
          branch_no: array2[a].branch_no,
          product_no: array2[a].product_no,
          product: array2[a].product,
          canBarcode: array2[a].canBarcode,
          description: array2[a].description,
          qty: array2[a].qty,
          qty_done: array2[a].qty_done,
          uom_id: array2[a].uom_id,
          price: array2[a].price,
          tax_id: array2[a].tax_id,
          tax: array2[a].tax,
          taxes: array2[a].taxes,
          discount: array2[a].discount,
          total: array2[a].total,
          edit: array2[a].edit,
          state: array2[a].state,
          uomList: array2[a].uomList
        }
        loop.push(obj)
      }
      return loop
    }
  },
  data () {
    return {
      max: 100,
      request_edit: '',
      request_void: '',
      selectAll: false,
      selected: []
    }
  },
  methods: {
    select () {
      this.selected = []
      var array = this.purchasingListVendor
      if (this.selectAll === true) {
        for (const i in array) {
          console.log(array[i])
          this.selected = []
        }
      } else {
        for (const i in array) {
          this.selected.push(array[i].id)
        }
      }
    },
    selectPurchasing () {
      var loop = []
      var array = this.selected
      for (let i = 0; i < array.length; i++) {
        var obj = this.purchasingList.find(d => d.id === array[i])
        loop.push(obj)
      }
      this.$emit('selectPurchasing', loop)
    },
    requestEdit: function () {
      this.$emit('getRequestEdit', this.request_edit)
    },
    requestVoid: function () {
      this.$emit('getRequestVoid', this.request_void)
    }
  }
}
</script>
